import type {
  ConfiguracionActualizarInput,
  ConfiguracionItem,
  ErrorLogListarQuery,
  ErrorLogPublic,
  ErrorLogResolverInput,
} from '@app/shared';

import { api } from '../../../lib/api';

export const erroresApi = {
  async list(query: Partial<ErrorLogListarQuery> = {}): Promise<{ errores: ErrorLogPublic[] }> {
    const { data } = await api.get<{ errores: ErrorLogPublic[] }>('/admin/errores', {
      params: query,
    });
    return data;
  },
  async resolver(id: string, input: ErrorLogResolverInput): Promise<{ error: ErrorLogPublic }> {
    const { data } = await api.patch<{ error: ErrorLogPublic }>(`/admin/errores/${id}`, input);
    return data;
  },
};

export const configuracionApi = {
  async list(): Promise<{ items: ConfiguracionItem[] }> {
    const { data } = await api.get<{ items: ConfiguracionItem[] }>('/admin/configuracion');
    return data;
  },
  async actualizar(clave: string, input: ConfiguracionActualizarInput): Promise<{ item: ConfiguracionItem }> {
    const { data } = await api.patch<{ item: ConfiguracionItem }>(`/admin/configuracion/${clave}`, input);
    return data;
  },
};
